import React from 'react'; 

export const Header: React.FC = () => {

    return (
        <h1>Zodiac Compatibility</h1>
    )

}